export default __webpack_public_path__ + "static/media/Support.caa21a11.svg";